<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="container content-wrap">
      <div class="row">
        <section class="choose-plan">
          <form @submit.prevent="proceedToRecharge">
            <RechareInfoCard />
            <div class="choose-plan__plans" v-if="plans.length > 0">
              <button
                class="choose-plan__plans__item"
                v-for="index in plans.length>3?3:plans.length"
                :key="plans[index - 1].amount"
                @click="selectPlan(plans[index - 1])"
                :class="
                  plans[index - 1].amount === selectedPlan
                    ? 'choose-plan__plans__item--active'
                    : ''
                "
                type="button"
              >
                <span class="choose-plan__plans__item__value">₹ {{ plans[index - 1].amount }}</span>
                <!-- <span class="choose-plan__plans__item__subtitle">{{plans[index].category}}</span> -->
              </button>
              <router-link
                :to="{name: 'View Plans', query: this.$route.query}"
                class="choose-plan__plans__item choose-plan__plans__item--link"
              >View Plans</router-link>
            </div>
            <div class="rupee">
              <input
                type="number"
                name
                id
                placeholder="Enter Amount"
                class="choose-plan__input"
                v-model="selectedPlan"
                v-numericOnly
                :min="minRechargeAmount"
              />
            </div>
            <p class="text-red text-center">{{ pageError }}</p>
            <p class="selected-plan__description">{{ selectedPlanDescription }}</p>
            <ActionButton
              title="Pay Now"
              :disabled="!(selectedPlan && selectedPlan >= minRechargeAmount)"
            />
          </form>
        </section>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import { mapGetters } from "vuex";
import RechareInfoCard from "./RechargeInfoCard/index";
import ActionButton from "@/components/ActionButton/index";
export default {
  name: "choose-plan",
  data() {
    return {
      pageError: "",
      query: {},
    };
  },
  components: { RechareInfoCard, ActionButton },
  computed: {
    ...mapGetters([
      "loggedIn",
      "plans",
      "planCategories",
      "operator",
      "region",
      "recharge_account_id",
      "selectedPlanDescription",
      "operators",
    ]),
    selectedPlan: {
      get() {
        return this.$store.state.recharge.selectedPlan;
      },
      set(value) {
        return this.$store.dispatch("selectPlan", {
          amount: value,
          description: "",
        });
      },
    },
    minRechargeAmount() {
      return this.operators.find((e) => e.operator === this.operator)
        .minRechargeAmount;
    },
  },
  mounted() {
    const params = {
      operator: encodeURIComponent(this.operator.trim()),
      region: encodeURIComponent(this.region.trim()),
    };
    this.$store.dispatch("getPlans", {
      type: this.$route.params.type,
      ...params,
    });
  },
  methods: {
    selectPlan(plan) {
      this.$store.dispatch("selectPlan", {
        amount: plan.amount,
        description: plan.description,
      });
      this.$router.push({ name: "ChoosePlan", query: this.$route.query });
    },
    proceedToRecharge() {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "BP_PLAN_SELECTED",
        propertyName: "AMOUNT",
        propertyValue: this.selectedPlan,
      });
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "BP_PLAN_SELECTED",
        propertyName: "BILL_TYPE",
        propertyValue: this.$route.params.type.toUpperCase(),
      });
      this.pageError = "";
      if (this.selectedPlan) {
        this.query.amount = this.selectedPlan;
        this.query.operator = this.operator;
        this.query.region = this.region;
        this.query.rechargeAccountId = this.recharge_account_id;
        this.$store
          .dispatch("doRecharge", {
            type: this.$route.params.type,
            params: this.query,
          })
          .then((response) => {
            const status =
              response.responseCode + "" === "-10"
                ? "PENDING"
                : response.responseCode + "" === "0"
                ? "APPROVED"
                : "DECLINED";
            if (typeof ePayLater !== "undefined" && ePayLater.paymentStatus) {
              ePayLater.paymentStatus(
                status,
                response.amount,
                status === "APPROVED"
                  ? ""
                  : status !== "PENDING"
                  ? response.responseDescription
                  : 'Your order is taking longer than expected. We will notify you if the transaction is successful. You can also check "Bill payments and Recharge History" for latest status.',
                response.transactionNumber ? response.transactionNumber : ""
              );
            } else if (
              typeof window.webkit !== "undefined" &&
              typeof window.webkit.messageHandlers !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater.postMessage !==
                "undefined"
            ) {
              window.webkit.messageHandlers.EpayLater.postMessage(
                JSON.stringify({
                  status: status,
                  amount: response.amount.toString(),
                  description:
                    status === "APPROVED" ? "" : response.responseDescription,
                  transactionId: response.transactionNumber,
                })
              );
            } else {
              if (status === "APPROVED") {
                this.$router.push({
                  name: "EplNewTransactionSuccess",
                  params: {
                    type: this.$route.params.type,
                    transactionInfo: {
                      transactionNumber: response.transactionNumber,
                    },
                  },
                });
              } else if (status === "DECLINED") {
                this.$router.push({
                  name: "EplNewTransactionFail",
                  params: {
                    type: this.$route.params.type,
                    responseMessage: response,
                  },
                });
              } else {
                this.$router.push({
                  name: "EplNewTransactionPending",
                  params: {
                    category: this.category,
                    type: this.$route.params.category,
                    responseMessage: {
                      responseDescription:
                        'Your order is taking longer than expected. We will notify you if the transaction is successful. You can also check "Bill payments and Recharge History" for latest status.',
                    },
                  },
                });
              }
            }
          })
          .catch((err) => {
            if (typeof ePayLater !== "undefined" && ePayLater.paymentStatus) {
              ePayLater.paymentStatus(
                "DECLINED",
                0.0,
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : "Failed due to unknown reason",
                err.response &&
                  err.response.data &&
                  err.response.data.transactionNumber
                  ? err.response.data.transactionNumber
                  : ""
              );
            } else if (
              typeof window.webkit !== "undefined" &&
              typeof window.webkit.messageHandlers !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater.postMessage !==
                "undefined"
            ) {
              window.webkit.messageHandlers.EpayLater.postMessage(
                JSON.stringify({
                  status: "DECLINED",
                  amount: "0.0",
                  description:
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                      ? err.response.data.message
                      : "Failed due to unknown reason",
                  transactionId:
                    err.response &&
                    err.response.data &&
                    err.response.data.transactionNumber
                      ? err.response.data.transactionNumber
                      : "",
                })
              );
            } else {
              this.$router.push({
                name: "EplNewTransactionFail",
                params: {
                  type: this.$route.params.type,
                  responseMessage: {
                    responseDescription:
                      err.response &&
                      err.response.data &&
                      err.response.data.message
                        ? err.response.data.message
                        : "Failed due to unknown reason",
                  },
                },
              });
            }
          });
      } else {
        this.pageError = "Please select a plan to proceed.";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.choose-plan {
  padding: 25px;
  .rupee {
    position: relative;
    &:before {
      position: absolute;
      content: "₹";
      left: 10px;
      top: 48%;
      font-size: 19px;
    }
  }
  &__input {
    font-size: 20px;
    padding: 8px 16px;
    &::placeholder {
      font-size: 16px;
      color: #d6d4d4;
    }
    padding-left: 25px;
    width: 100%;
    border-radius: 3px;
    border: solid 0.5px #d4d4d4;
    background-color: #ffffff;
    margin-top: 24px;
    &:focus {
      outline: solid 1px #3482fd;
    }
  }
  &__plans {
    display: grid;
    margin-top: 24px;
    justify-content: space-between;
    grid-gap: 0 10px;
    grid-template-columns: repeat(4, 1fr);
    &__item {
      text-align: center;
      border-radius: 2.7px;
      border: solid 0.5px rgba(0, 0, 0, 0.25);
      background: transparent;
      outline: none;
      box-shadow: none;
      padding: 10px 8px;
      &--active {
        background: #3482fd;
        .choose-plan__plans__item__value,
        .choose-plan__plans__item__subtitle {
          color: #fff;
        }
      }
      &--link {
        font-size: 16px;
        line-height: 1.25;
        color: #3482fd;
      }
      &__value {
        font-size: 16.2px;
        font-weight: 500;
        color: #4d4d4d;
        white-space: nowrap;
        margin-bottom: 5px;
      }
      &__subtitle {
        font-size: 10.8px;
        color: #979797;
      }
    }
  }
}
.selected-plan__description {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.26px;
  color: #757575;
  margin-top: 1rem;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/ChoosePlan.vue